<template>
  <div class="menu-toggle">
    <b-navbar toggleable type="light">
      <b-navbar-brand href="#">
        <div class="logo">
          <img src="amej-pay.png" width="100%" height="0" alt="Amejpay" style="width: 100%;
    height: auto;" />
        </div>
      </b-navbar-brand>

      <b-navbar-toggle target="navbar-toggle-collapse">
        <template #default="{ expanded }">
          <b-icon v-if="expanded" icon="chevron-bar-up"></b-icon>
          <b-icon v-else icon="chevron-bar-down"></b-icon>
        </template>
      </b-navbar-toggle>

      <b-collapse id="navbar-toggle-collapse" is-nav>
        <ul class="side-links">
          <router-link :to="{ name: 'merchant-dashboard' }"
            ><span class="material-icons"> dashboard </span
            ><span>Dashboard</span></router-link
          >
          <router-link :to="{ name: 'merchant-user-details' }"
            ><span class="material-icons"> people </span
            ><span>User Details</span></router-link
          >
          <a href="#" v-b-toggle.collapse-3>
            <div class="d-flex flex-grow-1 align-items-center">
              <div class="col pl-0">
                <p>
                  <span class="material-icons"> payment </span>
                  <span class="text">Transaction</span>
                </p>
              </div>
              <div class="col-2">
                <span class="material-icons"> navigate_next </span>
              </div>
            </div>
          </a>
          <b-collapse id="collapse-3" class="m-0">
            <router-link
              class="bg-gray"
              :to="{ name: 'merchant-success-transaction' }"
              ><h5>Success Transaction</h5>
            </router-link>
            <router-link
              class="bg-gray"
              :to="{ name: 'merchant-failed-transaction' }"
              ><h5>Failed Transaction</h5>
            </router-link>
          </b-collapse>
          <router-link :to="{ name: 'merchant-withdraw' }"
            ><span class="material-icons"> local_atm </span
            ><span>Withdraw</span></router-link
          >
          <a href="#">
            <div
              class="d-flex flex-grow-1 align-items-center"
              v-b-toggle.collapse-2
            >
              <div class="col pl-0">
                <p>
                  <span class="material-icons"> settings </span>
                  <span class="text">Settings</span>
                </p>
              </div>
              <div class="col-2">
                <span class="material-icons"> navigate_next </span>
              </div>
            </div>
          </a>
          <b-collapse id="collapse-2" class="m-0">
            <router-link class="bg-gray" :to="{ name: 'merchant-settings-key' }"
              ><h5>Key</h5>
            </router-link>
            <router-link class="bg-gray" :to="{ name: 'merchant-settings-url' }"
              ><h5>Url</h5>
            </router-link>
          </b-collapse>
          <router-link :to="{ name: 'merchant-documents' }"
            ><span class="material-icons"> picture_as_pdf</span
            ><span>Documents</span></router-link
          >
        </ul>
      </b-collapse>
    </b-navbar>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>